import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { selectCompareLeft, selectCompareRight } from '../../../store/slice'

const DynamicTitle = () => {
  const compareLeft = useSelector(selectCompareLeft)
  const compareRight = useSelector(selectCompareRight)
  const title = compareLeft || compareRight ? 'COMPARE_RATIO' : 'FILTERED_RATIO'

  return (
    <Element style={{ fontSize: 14 }} className={'fw600'}>
      <span style={{ marginLeft: 12 }}>
        <Translate value={`portfolio.finance.${title}`} />
      </span>
    </Element>
  )
}

export default DynamicTitle
